import * as tsx from 'vue-tsx-support';
import { ChevronDown, ChevronUp, LockIcon } from '@codegrade/icons';
import { PromiseButton } from '@/components/Button';
import Collapse from '@/components/Collapse';
import { Icon } from '@/components/Icon';
import { CoursesStore, UserStore } from '@/store';
import * as utils from '@/utils';
import './style.less';
export default tsx.component({
    name: 'exam-session-footer',
    /** @returns The initial data. */
    data() {
        return {
            hideFooter: false,
        };
    },
    computed: {
        /** @returns The current exam session state. */
        examState() {
            return UserStore.examSession();
        },
        /** @returns The course name for the isolated session. */
        courseName() {
            if (this.examState.tag === 'disabled') {
                return '';
            }
            return CoursesStore.getCourse()(this.examState.courseId).mapOrDefault(c => c.name, 'this course');
        },
        /** @returns The logged in user's name. */
        userName() {
            return UserStore.loggedInUser()
                .chain(u => u.name)
                .orDefault('');
        },
    },
    methods: {
        /**
         * Leave the exam by logging out.
         *
         * @returns The promise to leave the exam.
         */
        async handleLeaveExam() {
            return {
                onAfterSuccess: async () => {
                    const redirect = this.$route.fullPath;
                    await UserStore.logout({
                        revoke: true,
                        confirmSessionTermination: true,
                    });
                    this.$router.push({
                        name: 'login',
                        query: { redirect },
                    });
                },
            };
        },
    },
    /** @returns The rendered component. */
    render() {
        if (this.examState.tag === 'disabled') {
            return utils.emptyVNode();
        }
        return (<div class="exam-session-footer border rounded-top">
                <button class="mx-2 px-2 py-1 handle d-inline-block border border-bottom-0 rounded-top" v-cg-toggle="exam-session-footer-content-collapse" aria-label={`${this.hideFooter ? 'Show' : 'Hide'} the exam session footer`}>
                    <Icon icon={this.hideFooter ? ChevronUp : ChevronDown}/>
                </button>
                <Collapse id="exam-session-footer-content-collapse" v-model={this.hideFooter}>
                    <div class="px-2 py-1 flex items-center gap-2 exam-session-footer-content">
                        <Icon class="size-8 mr-1" icon={LockIcon}/>
                        <div class="grow">
                            <div class="font-bold">Exam session — {this.userName}</div>
                            <div class="small font-italic">
                                Your session is locked to {this.courseName}.
                            </div>
                        </div>
                        <PromiseButton class="shrink-0" semantic="critical" prominence={3} confirm={{
                type: 'modal',
                body: {
                    type: 'message',
                    message: `You are about to leave the exam for ${this.courseName}. This will end your session and log you out. Are you sure?`,
                },
            }} action={() => this.handleLeaveExam()} loadingAlertMessage="Leaving exam..." successAlertMessage="You have left the exam">
                            Leave Exam
                        </PromiseButton>
                    </div>
                </Collapse>
            </div>);
    },
});
